import { useState } from "react"

export const GlobalComponentState = () => {
    const [snackBarLoader, setSnackBarLoader] = useState({snackbar:false, msg:'', type:''})

    return {
        snackBarLoader: {data: snackBarLoader, set: setSnackBarLoader},
    }
}